/* istanbul ignore file */
import { Field } from '../services/logic-services/models';

export class DashboardFilter {
    id = "";
    projectId = "";
    selectedFields: Field[] = [];
    type = "";
    createdById = "";
    createdByName = "";
    dateCreated?: Date;
}
